import React, { memo } from 'react';
import { createUseStyles, Text } from 'hoi-poi-ui';
import useLoginLiterals from "../../../../lib/useLoginLiterals";
import { TransitionGroup, FadeTransition } from "../../../../components/Transitions";
import CenteredLayout from "../CenteredLayout";
import styles from "./styles.js";
const useStyles = createUseStyles(styles, 'Login');
const AuthBox = _ref => {
  let {
    logo,
    title,
    children,
    iframeURL
  } = _ref;
  const classes = useStyles();
  const {
    t,
    lang
  } = useLoginLiterals();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CenteredLayout, {
    iframeURL: iframeURL ? t(iframeURL) : null,
    lang: lang
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(TransitionGroup, null, /*#__PURE__*/React.createElement(FadeTransition, {
    transitionKey: "login",
    show: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.logo
  }, logo), /*#__PURE__*/React.createElement(Text, {
    className: classes.title,
    type: "h6"
  }, title), children)))));
};
export default /*#__PURE__*/memo(AuthBox);